import { HttpResult } from 'widgets-for-react'
import { VerpleegafdelingItem } from '../verpleegafdelingenOverview/verpleegafdelingenOverviewState'
import { VerpleegafdelingenFilters } from '../../utils/filtersToQueryParams'
import { SpaarneCentrumType, SpaarneDepartmentType } from '../../utils/spaarneIcons'
import { parsePhoneNumber } from '../../utils/phoneNumber'
import { LocationApiClient } from '../../backendApi/generated'

const locationApiClient = new LocationApiClient(window.location.origin)

export const getVerpleegafdelingenOverviewItems = async (
  filters: VerpleegafdelingenFilters
): Promise<HttpResult<VerpleegafdelingItem[]>> => {
  let locationId: number | undefined = undefined
  if (filters.locationName) {
    const locationResponse = await locationApiClient.getId(filters.locationName)
    if (locationResponse !== 0) locationId = locationResponse
  }

  const locations = await locationApiClient.getFacilities(locationId)
  return {
    kind: 'result',
    status: 200,
    value: locations.map((l) => ({
      clinic: {
        phoneNumber: (l.ClinicType!.PhoneNumber ?? []).map(x=>({
            ...parsePhoneNumber(x.PhoneNumber!),
            description: x.Description ?? "",
            title: x.Title ?? ""
          })),
        visitingTimes: l.ClinicType!.VisitTime ?? "",
        route: l.ClinicType!.Route ?? "",
      },
      // Priority: Department → Subdepartment → Centrum → Subcentrum.
      // Handles records where an editor filled in multiple fields, or where the
      // facility structure is linked to a Centrum rather than a Department.
      facility: l.Department?.Title
        ? { kind: 'department' as const, title: l.Department.Title as SpaarneDepartmentType }
        : l.Subdepartment?.Title
        ? { kind: 'department' as const, title: l.Subdepartment.Title as SpaarneDepartmentType }
        : l.Centrum?.Title
        ? { kind: 'centrum' as const, title: l.Centrum.Title as SpaarneCentrumType }
        : l.Subcentrum?.Title
        ? { kind: 'centrum' as const, title: l.Subcentrum.Title as SpaarneCentrumType }
        : { kind: 'department' as const, title: '' as SpaarneDepartmentType },
    })),
  }
}
